import React, { memo } from 'react'
import { Button } from '@mui/material'

import { mergeToNewObject } from '../../../util/object.helpers'
import FaIcon from '../faIcon/FaIcon'

const CustomButton = ({
  label,
  to,
  sx,
  noPadding,
  fullWidth = false,
  autoWidth = false,
  color = 'primary',
  variant = 'contained',
  size = 'large',
  icon,
  ...restProps
}) => {
  return (
    <Button
      to={to}
      sx={mergeToNewObject(
        !noPadding && {
          pt: 1.3,
          pb: 1.3
        },
        { minWidth: !autoWidth ? 240 : 80 },
        sx
      )}
      fullWidth={fullWidth}
      color={color}
      variant={variant}
      size={size}
      startIcon={icon && <FaIcon icon={icon} />}
      {...restProps}
    >
      {label}
    </Button>
  )
}

export default memo(CustomButton)
